import { Injectable } from '@angular/core';
import { BaseProvider } from './base';

interface ErrorCallbackItem {
    callback: Function;
    boundCallback?: Function;
}

@Injectable()
export class ErrorCallbackProvider extends BaseProvider {
    public ignoreErrorsCallbacks: ErrorCallbackItem[] = [];

    constructor() {
        super();
    }

    /**
     * Register callback that will be run before an error is thrown
     *
     * @param {Function} cb The callback function to register.  Callback function must accept the error and return a boolean
     * @param {any} boundThis If this function needs to be bound, pass the `this` to this function
     * @returns {string} The key under which the callback is registered
     * @memberof NeuralaErrorHandler
     */
    public registerErrorCheck(cb: Function, boundThis: any = null): void {
        this.ignoreErrorsCallbacks.push({
            callback: cb,
            boundCallback: boundThis ? cb.bind(boundThis) : null
        });
    }

    /**
     * Remove the registered error check callback function
     *
     * @param {string} key The key under which the callback is registered.  This is
     * returned by the `NeuralaErrorHandler.registerErrorCheck` function call
     * @memberof NeuralaErrorHandler
     */
    public removeErrorCheck(cb: Function): void {
        for (let callbackIndex = 0; callbackIndex < this.ignoreErrorsCallbacks.length; callbackIndex++) {
            if (cb == this.ignoreErrorsCallbacks[callbackIndex].callback) {
                this.ignoreErrorsCallbacks.splice(callbackIndex, 1);
            }
        }
    }

    public isCallbackRegistered(cb: Function): boolean {
        return !!this.ignoreErrorsCallbacks.find(cbInstance => cbInstance.callback == cb);
    }

    public async shouldIgnoreError(finalError: any): Promise<boolean> {
        for (const cb of this.ignoreErrorsCallbacks) {
            const callback = cb.boundCallback ? cb.boundCallback : cb.callback;
            if (callback && (await callback(finalError))) {
                return true;
            }
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/providers/error-callback.ts